import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { NewPasswordRequired } from "@features/Auth/NewPasswordRequired";
import { toast } from "@shared/services/toast";
import { useOAuthParams } from "@features/Auth/hooks/useOAuthParams";
import { RootLayout } from "@shared/layouts/RootLayout";
import { PageContainer } from "./styles";

const SUPPORTED_CHALLENGES = ["NEW_PASSWORD_REQUIRED"];

export const AuthChallenge = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const oauthData = useOAuthParams();

  const data = useMemo(() => {
    const email: string = location.state?.email;
    const session: string = location.state?.session;
    const challengeName: string = location.state?.challengeName;
    const redirect: string | undefined = location.state?.redirect;

    if (!email || !session || !challengeName) return null;

    return {
      email,
      session,
      challengeName,
      redirect,
    };
  }, [location]);

  const isChallengeSupported =
    data && SUPPORTED_CHALLENGES.includes(data.challengeName);

  useEffect(() => {
    if (!data) {
      navigate("/login", { replace: true });
      return;
    }

    if (!isChallengeSupported) {
      toast.error(
        "Login method not supported. If this error persists, please contact the support."
      );
      navigate("/login", { replace: true });
    }
  }, [data, isChallengeSupported, navigate]);

  if (!isChallengeSupported) return null;

  return (
    <RootLayout theme="light">
      <PageContainer>
        {data.challengeName === "NEW_PASSWORD_REQUIRED" && (
          <NewPasswordRequired
            email={data.email}
            session={data.session}
            redirect={data.redirect}
            oauthData={oauthData}
          />
        )}
      </PageContainer>
    </RootLayout>
  );
};
